import React, { Component } from 'react'
import {Section, Title, SectionButton} from "../../utils"
import styled from "styled-components"
import {Link} from "gatsby"
import {styles} from "../../utils"

export default class QuickInfo extends Component {
    render() {
        return (
            <Section>
                <Title message="Burger Times" title="notre mission"/>
                <QuickInfoWrapper>
                    <p className="text">
                        Pour les amateurs de cuisine rapide et équilibrée! Spécialistes de la restauration rapide, nous vous vous invitons à savourer des mets gourmands.
                        Nous vous proposons une carte variée et riche, qui répondra à tous les amateurs du fast-food.
                    </p>
                    <Link to="/about/" style={{textDecoration: 'none'}}>
                        <SectionButton style={{ margin: '2rem auto'}}>About</SectionButton>
                    </Link>           
                </QuickInfoWrapper>
            </Section>
        )
    }
}

const QuickInfoWrapper = styled.div`
  width: 90%;
  margin: 2rem auto;
  .text {
    line-height: 2em;
    color: ${styles.colors.mainGrey};
    word-spacing: 0.2rem;
  }

  @media (min-width: 768px) {
    width: 70%;
  }
  @media (min-width: 992px) {
    width: 60%;
  }
`
